// Marketplace API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createMarketplaceApi(client) {
  return {
    async browseMarketplace(filters = {}) {
      const params = new URLSearchParams({ action: 'browse', ...filters })
      return this.call(`/marketplace?${params}`)
    },

    async myPublishedDecks() {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'myPublished' })
      })
    },

    async publishDeck(deckId) {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'publish', deckId })
      })
    },

    async unpublishDeck(deckId) {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'unpublish', deckId })
      })
    },

    async getPublishedDeck(deckId) {
      return this.call(`/marketplace?${new URLSearchParams({ action: 'getPublishedDeck', deckId })}`)
    },

    async importFromMarketplace(deckId) {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'importFromMarketplace', deckId })
      })
    },

    async likeDeck(deckId) {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'likeDeck', deckId })
      })
    },

    async unlikeDeck(deckId) {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'unlikeDeck', deckId })
      })
    },

    async getDeckLikes(deckId) {
      return this.call(`/marketplace?${new URLSearchParams({ action: 'getDeckLikes', deckId })}`)
    },

    async rateDeck(deckId, rating, review = '') {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'rateDeck', deckId, rating, review })
      })
    },

    async getDeckReviews(deckId) {
      return this.call(`/marketplace?${new URLSearchParams({ action: 'getDeckReviews', deckId })}`)
    },

    async deleteReview(reviewId) {
      return this.call('/marketplace', {
        method: 'POST',
        body: JSON.stringify({ action: 'deleteReview', reviewId })
      })
    }
  }
}
